import mainPage from "./component/mainpage";
import aboutUs from "./component/aboutUs";
import license from "./component/license";
import contactUs from "./component/contactUs";
import product from "./component/product";
import allProduct from "./component/all";
import Category from "./component/Category";
import Welfare from "./component/Welfare";
import WelfareProduct from "./component/WelfareProduct";
import brand from "./component/brand";
import Search from "./component/Search";
import Type from "./component/type";
import EmailForm from "./component/EmailForm";

export default [
  {
    path: "/",
    component: mainPage
  },
  {
    path: "/about-us",
    component: aboutUs
  },
  { path: "/license", component: license },
  { path: "/contact-us", component: contactUs },
  { path: "/product/:id", component: product },
  { path: "/brand/:id", component: brand },
  { path: "/type/:tid/:cid", component: Type },
  { path: "/type/:tid", component: Type },
  { name: "Category", path: "/category/:catId", component: Category },
  // { name: "Welfare", path: "/welfare/", component: Welfare },
  // { path: "/welfare/:id", component: WelfareProduct },
  { name: "Search", path: "/search", component: Search },
  {
    name: "SearchValue",
    path: "/search/:value",
    component: Search
  },
  { name: "All", path: "/products", component: allProduct },
  { path: "/form", name: "EmailForm", component: EmailForm }
];



// WEBPACK FOOTER //
// ./src/router.js